"use strict";

import React from "react";

import FormikField, {
  FIELD_TYPE,
} from "../../../../shared/react/components/FormikField";
import { useTranslator } from "../../../../shared/react/hooks";
import styles from "./TicketExchangeConfirmationReason.module.scss";

const TicketExchangeConfirmationReason = ({ reasonLabel }) => {
  const t = useTranslator();

  return (
    <div className={styles.refundReason}>
      <FormikField
        as={FIELD_TYPE.TEXTAREA}
        name="reason"
        label={reasonLabel}
        className={styles.textarea}
        gutterBottom
      />
      <FormikField
        as={FIELD_TYPE.CHECKBOX}
        name="requestedByPhone"
        label={t("refundPages.requestedPhone")}
        gutterBottom
      />
      <br />
      <FormikField
        as={FIELD_TYPE.CHECKBOX}
        name="requestedByEmail"
        label={t("refundPages.requestedEmail")}
      />
    </div>
  );
};

export default TicketExchangeConfirmationReason;
